import React from "react";
import "./Contact.css";
import Banner from "../../images/banner.jpg";
import NavBar from "../Layout/NavBar";
import Footer from "../Footer/Footer";

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-banner">
        <img src={Banner} alt="Flickerbound Banner" />
      </div>

      <NavBar />
      
        <div className="contact-section">
            <h1>Contact Us</h1>
            <p>
            We’re here to help with questions about your order, product details,
            or anything related to Flickerbound.
            </p>

            <section className="contact-section">
                <h2>Email</h2>
                <p>
                    You can reach us directly at:
                    <br />
                    <strong>harmonyhaventreasures@gmail.com</strong>
                </p>
            </section>

            <section className="contact-section">
                <h2>Response Time</h2>
                <p>
                    We typically respond within 1–3 business days. Response times may
                    vary during holidays or high‑volume periods.
                </p>
            </section>

            <section className="contact-section">
                <h2>Future Support Options</h2>
                <p>
                    A full support system—including a contact form and customer inbox—
                    will be added to the website soon. For now, email is the best way to
                    reach us.
                </p>
            </section>
        </div>

      <Footer />
    </div>
  );
};

export default Contact;